var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    //links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}


$(document).ready(function(){
  
var member_success_modal = jQuery('.bs-logged-in #free-mmbr-success');
var member_success_close = jQuery('#free-mmbr-success .close');
var member_success_content = jQuery('#free-mmbr-success .modal-content');

var success_modal = document.getElementById("free-mmbr-success");
  
  //console.log(localStorage.fromRegister);

  var show_modal = 0;
  if($('body').hasClass("bs-logged-in")) show_modal = 1;
  if($('body').hasClass("bs-paid-member")) show_modal = 0;
  
//console.log(show_modal);  

if(localStorage.fromRegister == 'true'){
  
if(show_modal == 1) {
  
member_success_modal.show();
  
jQuery('#free-mmbr-success .close').on("click",function() {
 	member_success_modal.hide();
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  //console.log('clicked');  
  if (event.target == success_modal) {
    member_success_modal.hide();
  }
}
 
  localStorage.fromRegister = false;

  }//if logged in
}//if(localStorage.fromRegister == true)
  
});


//console.log('[data-show-mobile-menu]'.length);

//$('body').on('click', '[data-show-mobile-menu="false"]', function () {
  //console.log('[data-show-mobile-menu]'.length);
    //$('.mobile-menu__toggle-icon').addClass('is-active');
    //$('[data-show-mobile-menu]').attr('data-show-mobile-menu', true);
  
  //setTimeout(function () {
      //$('body').addClass('mobile-menu--opened');
    //}, 10);
  
//});
//$('body').on('click', '[data-show-mobile-menu="true"]', function () {
      //$('body').removeClass('mobile-menu--opened');
      
    //$('.mobile-menu__toggle-icon').removeClass('is-active');
    //$('[data-show-mobile-menu]').attr('data-show-mobile-menu', false);
//});
